import { render, staticRenderFns } from "./DownloadOrPreviewRecords.vue?vue&type=template&id=a61cbf90&"
import script from "./DownloadOrPreviewRecords.vue?vue&type=script&lang=js&"
export * from "./DownloadOrPreviewRecords.vue?vue&type=script&lang=js&"
import style0 from "./DownloadOrPreviewRecords.vue?vue&type=style&index=0&id=a61cbf90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports